var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{class:'progress-bar' + ' ' + _vm.color,staticStyle:{"display":"flex","align-items":"center"},style:('width:' + _vm.percentage + '%'),attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":0,"aria-valuemax":_vm.goal}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0120d5a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin-panel/components/common/ProgressBar.vue
// module id = n1f6
// module chunks = 0